import { useState, useEffect, useMemo } from 'react';
import { MultiScreenController } from 'services/multiscreen/controllers/MultiScreenController';
import { useMultiScreenController } from 'services/multiscreen/hooks/useMultiScreenController';

function useMultiScreenAvailable(controller: MultiScreenController | undefined) {
    const [available, setAvailable] = useState(false);

    useEffect(() => {
        if (!controller) return;

        setAvailable(controller.available);

        const listener = () => {
            setAvailable(controller.available);
        };
        controller.addEventListener('available', listener);
        return () => controller.removeEventListener('available', listener);
    }, [controller]);

    return available;
}

export function useMultiScreenEnabler() {
    const controller = useMultiScreenController();
    const presentationAvailable = useMultiScreenAvailable(controller);

    const onMultiScreenClick = useMemo(
        () => presentationAvailable
            ? () => controller?.start()
            : undefined
        , [controller, presentationAvailable]);

    return {
        multiScreenSupported: controller != undefined,
        onMultiScreenClick,
    };
}
